const BATCH_SIZE = 3;

export function initHomeLatest() {
  const list = document.querySelector('[data-wla-home-latest-list]');
  const sentinel = document.querySelector('[data-wla-home-latest-sentinel]');
  const status = document.querySelector('[data-wla-home-latest-status]');
  if (!list || !sentinel || !status) return;

  const items = [...list.querySelectorAll('[data-wla-home-latest-item]')];
  if (!items.length) return;

  function visibleCount() {
    return items.filter((item) => !item.hidden).length;
  }

  function updateStatus() {
    const visible = visibleCount();
    status.textContent = visible < items.length
      ? `${visible} af ${items.length} nyheder indlæst · fortsæt med at scrolle`
      : `Alle ${items.length} nyheder er indlæst`;
  }

  function revealNext(amount = BATCH_SIZE) {
    items.filter((item) => item.hidden).slice(0, amount).forEach((item) => {
      item.hidden = false;
    });
    updateStatus();
  }

  updateStatus();

  if (!('IntersectionObserver' in window)) {
    revealNext(items.length);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    revealNext();
    if (visibleCount() >= items.length) observer.disconnect();
  }, { rootMargin: '320px 0px' });

  observer.observe(sentinel);
}
